import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import {Ok, Paragraph, Title} from './DeliveryMinimumModal.style';
import {FormattedMessage} from 'react-intl';
import {Wrapper} from '../Modal/modal.style';
import Price from '../Price/Price';

class DeliveryMinimumModal extends PureComponent {
  render() {
    const {closeModalCallback} = this.props;

    return (
      <Wrapper>
        <Title><FormattedMessage id="basket.deliveryMinimum" /></Title>
        <Paragraph>
          <FormattedMessage
            id="checkout.deliveryMinimumAmountErrorLine1"
            values={{
              price: <Price amount={this.props.minimumAmount - this.props.total} />,
              minimumAmount: <Price amount={this.props.minimumAmount} />
            }}
          />
        </Paragraph>
        <Ok onClick={closeModalCallback}>Ok</Ok>
      </Wrapper>
    );
  }
}

DeliveryMinimumModal.propTypes = {
  closeModalCallback: PropTypes.func,
  minimumAmount: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired
};

export default DeliveryMinimumModal;



// WEBPACK FOOTER //
// ./components/DeliveryMinimumModal/DeliveryMinimumModal.js